import { createFileRoute } from "@tanstack/react-router";
import { FunilCursoPage } from "@/components/funis/FunilCursoPage";
import { FUNIS } from "@/lib/funis/config";

const cfg = FUNIS["funil-sdfp"];

export const Route = createFileRoute("/funil-sdfp")({
  head: () => ({
    meta: [
      { title: "Curso Gratuito: Dor Femoropatelar (SDFP)" },
      { name: "description", content: "Curso online e gratuito sobre Síndrome da Dor Femoropatelar. Anatomia, avaliação, tratamento e retorno às atividades. Certificado de 5h." },
      { property: "og:title", content: "Curso Gratuito: Dor Femoropatelar (SDFP)" },
      { property: "og:description", content: "Dor femoropatelar não se conduz com protocolo copiado. Aprenda a avaliar, decidir e conduzir com segurança." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://fisioemortopedia.com.br/funil-sdfp" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Curso Gratuito: Dor Femoropatelar (SDFP)" },
      { name: "twitter:description", content: "Curso 100% gratuito, online, com certificado de 5h." },
    ],
    links: [{ rel: "canonical", href: "https://fisioemortopedia.com.br/funil-sdfp" }],
  }),
  component: () => <FunilCursoPage cfg={cfg} />,
});
